export default "__VITE_ASSET__CZRr5Fe1__"